import { WILDCARD, Wildcard } from "./types";

export const isWildcard = <T>(
  value: readonly T[] | Wildcard
): value is Wildcard => value === WILDCARD;

export const isAllowed = <T>(
  key: T,
  allowed: readonly T[] | Wildcard
): boolean => isWildcard(allowed) || allowed.includes(key);

export const isAutomationAllowed = (
  name: string,
  allowed: readonly string[] | Wildcard | undefined
): boolean => !allowed || isAllowed(name, allowed);
